import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthStore } from '../store/auth-store';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const apiUrl = environment.apiUrl.replace(/\/+$/, '');

  if (req.url.startsWith(apiUrl + '/')) {
    const authStore = inject(AuthStore);
    const accessToken = authStore.accessToken();
    if (accessToken) {
      const newReq = req.clone({
        headers: req.headers.append('Authorization', `Bearer ${accessToken}`),
      });
      return next(newReq);
    }
  }

  return next(req);
};
